import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const colorMap: Record<string, Record<string, string>> = {
  registration: {
    confirmed: 'bg-green-100 text-green-800 border-green-200',
    pending: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    pending_payment: 'bg-red-100 text-red-800 border-red-200',
    waitlist: 'bg-orange-100 text-orange-800 border-orange-200',
    cancelled: 'bg-gray-100 text-gray-600 border-gray-200',
    rejected: 'bg-red-100 text-red-800 border-red-200',
    approved: 'bg-green-100 text-green-800 border-green-200',
    none: 'bg-gray-100 text-gray-600 border-gray-200',
    needs_partner: 'bg-red-100 text-red-800 border-red-200',
  },
  payment: {
    paid: 'bg-green-100 text-green-800 border-green-200',
    pending: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    refunded: 'bg-blue-100 text-blue-800 border-blue-200',
    failed: 'bg-red-100 text-red-800 border-red-200',
  },
  draw: {
    pending: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    in_progress: 'bg-blue-100 text-blue-800 border-blue-200',
    success: 'bg-green-100 text-green-800 border-green-200',
    failed: 'bg-red-100 text-red-800 border-red-200',
    locked: 'bg-purple-100 text-purple-800 border-purple-200',
  },
  event: {
    open: 'bg-green-100 text-green-800 border-green-200',
    closed: 'bg-gray-100 text-gray-600 border-gray-200',
    in_progress: 'bg-blue-100 text-blue-800 border-blue-200',
    completed: 'bg-purple-100 text-purple-800 border-purple-200',
    cancelled: 'bg-red-100 text-red-800 border-red-200',
    active: 'bg-green-100 text-green-800 border-green-200',
    scratched: 'bg-orange-100 text-orange-800 border-orange-200',
    turned_out: 'bg-gray-100 text-gray-600 border-gray-200',
  },
  scoring: {
    scored: 'bg-green-100 text-green-800 border-green-200',
    pending: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    no_time: 'bg-gray-100 text-gray-600 border-gray-200',
    disqualified: 'bg-red-100 text-red-800 border-red-200',
  },
  role: {
    admin: 'bg-red-100 text-red-800 border-red-200',
    delegate: 'bg-purple-100 text-purple-800 border-purple-200',
    secretary: 'bg-blue-100 text-blue-800 border-blue-200',
    system: 'bg-gray-100 text-gray-800 border-gray-200',
    member: 'bg-green-100 text-green-800 border-green-200',
    user: 'bg-sky-100 text-sky-800 border-sky-200',
  },
};

const defaultColors = 'bg-gray-100 text-gray-700 border-gray-200';

interface StatusBadgeProps {
  status: string;
  variant?: 'registration' | 'payment' | 'draw' | 'event' | 'scoring' | 'role';
  className?: string;
}

export function StatusBadge({ status, variant = 'registration', className }: StatusBadgeProps) {
  if (!status) return null;
  const colors = colorMap[variant]?.[status.toLowerCase()] ?? defaultColors;
  const label = status.replace(/_/g, ' ');

  return (
    <Badge variant="outline" className={cn(colors, 'capitalize', className)}>
      {label}
    </Badge>
  );
}
